import { Box, Button, Drawer, FormControlLabel, Tab, Typography } from "@mui/material";
import { useLayoutEffect, useMemo, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { ButtonsDrawer } from "../buttons/buttonDrawer";
import { EvidencesTypeEnum } from "../../utils/enums/evidences";
import { DinamicFormRefValues, DynamicRefRef } from "../dynamicFormRef/types";
import { DrawerEvidencesProps, EvidenceData, EvidenceOptionType } from "../../hooks/evidences/typyng";
import { evidenceDefaultValues, useDrawerInputs } from "../../hooks/evidences/useEvidences";
import { ArrowBack } from "../arrowBack";
import SimpleModal from "../modal/simpleModal";
import { ModalState } from "../../pages/questionnaire/pages/detail/typing/types";
import { useRefs } from "../../hooks/useReactHookModified";
import { Item } from "./components/items";
import { useStyles } from "./styles";
import { IOSSwitch } from "../dynamicFormRef/switch";
import { evidenceTemplate, expandTemplate, folioManagementDefault } from './utils'
import { useEvidenceListType } from "./evidencelistTypes";
import { DinamicForm } from "../dinamicForm";
import { InputModel } from "../../utils/types";
import { IsBlur, onChangeEvent } from "../../utils/types/generals";
import { typeUser } from "../../pages/questionnaire/pages/detail/methods/actionPlan/contants";
import { removeAllReference } from "../../utils/methods/removedReference";

const DrawerEvidences = ({ multiple, headerLabel, optionType, disabledField, ...props }: DrawerEvidencesProps) => {
  const selectEvidence = useMemo(() => {
    return {
      creator: optionType == EvidenceOptionType.CREATOR,
      folioManagement: optionType == EvidenceOptionType.FOLIO_MANAGEMENT,
      creation: optionType == EvidenceOptionType.CREATION,
      activityManagement: optionType == EvidenceOptionType.ACTIVITY_MANAGEMENT,
    }
  }, [optionType])
  const { list } = useEvidenceListType({ optionType })
  const styles = useStyles()
  const { model } = useDrawerInputs()
  const { t } = useTranslation()
  const refs = useRefs<DynamicRefRef>()
  const [expand, setExpand] = useState<Record<string, boolean>[]>([{}])
  const [options, setOptions] = useState({
    sameConfig: false,
  })
  const [data, setData] = useState<Array<EvidenceData>>([])
  const [tabValue, setTabValue] = useState('1')
  const index = useMemo(() => ({
    index: Number(tabValue) - 1,
    item: list?.find(item => tabValue == item.value)
  }), [tabValue])
  const canSeeObservation = useMemo(() => !!index?.item?.option ? [EvidencesTypeEnum.OBSERVATION_COMMENT].includes(index.item.option) : false, [index?.item?.option])
  const currentData = data?.[index.index]
  const [existCheck, setExistCheck] = useState<Record<string, boolean>[]>([{}])
  const [modal, setModal] = useState<ModalState>({ open: false, title: '', description: '' })
  const inputObservationComment = {
    required: {
      name: 'required',
      label: t('general.tags.requireComment'),
      type: 'switch',
    },
    maxCharacters: {
      name: 'maxCharacters',
      label: t('general.tags.maxCharacters'),
      type: 'number',
      wrapChildren: ({ children }) => <Box sx={styles.maxInput}>{children}</Box>,
      rest: {
        type: 'number',
        min: 1,
        // max: 255,
      }
    },
  } as Record<string, InputModel>
  const cancel = () => {
    setExpand([{}])
    props.cancel()
    setData([])
  }
  const save = () => {
    let existSomeError = false

    for (const index in data) {
      for (const [key, value] of Object.entries(expand[index])) {
        if (value) {
          const refInput = refs.refsByKey?.[`${key}-input-${index + 1}`]

          if (!existSomeError) {
            const inputErrors = Object.values(refInput?.getErrors() ?? {})?.length

            if (!!inputErrors || !!existCheck[index]?.[key]) { existSomeError = true }
          }
        }
      }
    }

    if (!existSomeError) {
      setExpand([{}])
      let dataBody: EvidenceData[] = []
      if (options.sameConfig) {
        if (Object.values(data[0] ?? {}).filter(item => !!item)?.length) {
          dataBody.push(data[0])
          dataBody.push(data[1])
        }
      } else {
        const existSomeEvidence = !!data.flatMap(item => Object.values(item ?? {}).flatMap(item => [item])).filter(item => !!item)?.length
        if (existSomeEvidence) {
          dataBody = data
        }
      }
      if (!!dataBody?.length) {
        setTabValue('1')
        setOptions({ sameConfig: false })
        props.save(dataBody, options)
        setData([])
        return
      }
      setModal(prev => ({
        ...prev,
        open: true,
        title: t('Questionarie.mustBeSelectSomeEvidence'),
        description: '',
        cancel: undefined,
        close: undefined,
        cancelText: undefined,
        confirm: () => {
          closeModal()
        }
      }))
    } else {
      setModal(prev => ({
        ...prev,
        open: true,
        title: t('general.goBackToConfig'),
        description: t('general.changeWillBeDiscarded')
      }))
    }
  }

  const closeEvidence = () => {
    if (!disabledField) {
      setModal(prev => ({
        ...prev,
        open: true,
        title: '¿Quieres volver a la configuración anterior?',
        description: 'Los cambios previos serán descartados.',
        confirm: undefined,
        cancel: () => { }
      }))
    } else {
      props.cancel()
    }
  }
  const addData = ({ key, name, value }: { name: string; value: DinamicFormRefValues; oldValue: DinamicFormRefValues; key: string }) => {
    const dataCopy = structuredClone(data)
    const existCheckCopy = structuredClone(existCheck)

    if (options.sameConfig) {
      if (name == 'active') {
        const expandCopy = structuredClone(expand)
        const defaultValues = evidenceDefaultValues({ active: !!value })
        const newValues = { ...defaultValues?.[key as EvidencesTypeEnum] }
        console.log({ expandCopy, defaultValues, newValues, value })

        refs.refsByKey?.[`${key}-header-${index.index + 1}`]?.setValues({ name: 'required', value: true })
        refs.refsByKey?.[`${key}-check-${index.index + 1}`]?.reset(newValues)
        refs.refsByKey?.[`${key}-input-${index.index + 1}`]?.reset(newValues)
        

        if (!!value) {
          dataCopy[0] = { ...dataCopy[0] ?? {}, [key]: { ...dataCopy?.[0]?.[key] ?? {}, ...newValues, type: typeUser.CREATOR } }
          dataCopy[1] = { ...dataCopy[1] ?? {}, [key]: { ...dataCopy?.[1]?.[key] ?? {}, ...newValues, type: typeUser.SOLVER } }
        } else {
          dataCopy[0] = { ...dataCopy[0] ?? {}, [key]: undefined }
          dataCopy[1] = { ...dataCopy[1] ?? {}, [key]: undefined }
          console.log({dataCopy})
          existCheckCopy[index.index] = { ...existCheckCopy[index.index] ?? {}, [key]: false }
          setExistCheck(() => (existCheckCopy))
        }
        setData(() => dataCopy)
        expandCopy[0] = { ...expandCopy[0] ?? {}, [key]: !!value }
        expandCopy[1] = { ...expandCopy[1] ?? {}, [key]: !!value }
        setExpand(() => (expandCopy))
      } else {
        const check = Object.values(model[key]?.check ?? {})

        if (!!check?.length) {
          const newData = { ...data[index.index], [key]: { ...data[index.index]?.[key] ?? {}, [name]: value } }
          const existCheck = !Object.values(model[key]?.check ?? {})?.some(item => !!newData?.[key]?.[item?.name ?? ''])
          existCheckCopy[index.index] = { ...existCheckCopy[index.index] ?? {}, [key]: existCheck }
          setExistCheck(() => (existCheckCopy))
        }
        dataCopy[0] = { ...dataCopy[0] ?? {}, [key]: { ...dataCopy[0]?.[key] ?? {}, [name]: value, type: typeUser.CREATOR } }
        dataCopy[1] = { ...dataCopy[1] ?? {}, [key]: { ...dataCopy[1]?.[key] ?? {}, [name]: value, type: typeUser.SOLVER } }
        setData(() => dataCopy)
      }
    } else {
      if (name == 'active') {
        const expandCopy = structuredClone(expand)
        const defaultValues = evidenceDefaultValues({ active: !!value })
        const newValues = { ...defaultValues?.[key as EvidencesTypeEnum] }

        refs.refsByKey?.[`${key}-header-${index.index + 1}`]?.setValues({ name: 'required', value: true })
        refs.refsByKey?.[`${key}-check-${index.index + 1}`]?.reset(newValues)
        refs.refsByKey?.[`${key}-input-${index.index + 1}`]?.reset(newValues)

        if (!!value) {
          dataCopy[index.index] = { ...dataCopy[index.index] ?? {}, [key]: { ...dataCopy?.[index.index]?.[key] ?? {}, ...newValues, type: index?.item?.type } }

        } else {
          dataCopy[index.index] = { ...dataCopy[index.index] ?? {}, [key]: undefined }
          existCheckCopy[index.index] = { ...existCheckCopy[index.index] ?? {}, [key]: false }
          setExistCheck(() => (existCheckCopy))
        }
        setData(() => dataCopy)
        expandCopy[index.index] = { ...expandCopy[index.index] ?? {}, [key]: !!value }
        setExpand(() => (expandCopy))
      } else {
        const check = Object.values(model[key]?.check ?? {})

        if (!!check?.length) {
          const newData = { ...data[index.index], [key]: { ...data[index.index]?.[key] ?? {}, [name]: value } }
          const existCheck = !Object.values(model[key]?.check ?? {})?.some(item => !!newData?.[key]?.[item?.name ?? ''])
          existCheckCopy[index.index] = { ...existCheckCopy[index.index] ?? {}, [key]: existCheck }
          setExistCheck(() => (existCheckCopy))
        }
        dataCopy[index.index] = { ...dataCopy[index.index] ?? {}, [key]: { ...dataCopy[index.index]?.[key] ?? {}, [name]: value } }
        setData(() => dataCopy)
      }
    }

  }

  const validateData = ({ key, name, value }: { name: string; value: DinamicFormRefValues; oldValue: DinamicFormRefValues; key: string }) => {
    const setValues = refs.refsByKey[`${key}-input-${index.index + 1}`]?.setValues
    const cleanError = refs.refsByKey[`${key}-input-${index.index + 1}`]?.cleanError
    const datacopy = structuredClone(data)
    if (cleanError) {
      cleanError(name)
    }
    if (['minAmount', 'maxAmount'].includes(name)) {
      const datainput = data?.[index.index]?.[key]
      const minAmount = name == 'minAmount' ? value : datainput?.minAmount
      const maxAmount = name == 'maxAmount' ? value : datainput?.maxAmount

      if (!value || (Number(minAmount ?? 1) > Number(maxAmount ?? 1))) {
        let newValue = name == 'minAmount' ? maxAmount : minAmount
        if (!value && name == 'minAmount') {
          newValue = '1'
        }
        if (setValues) {
          setValues({ name, value: (newValue as string) || '1' })
        }
        datacopy[index.index] = { ...datacopy[index.index], [key]: { ...datacopy[index.index]?.[key] ?? {}, [name]: newValue || '1' } }
      } else {
        datacopy[index.index] = { ...datacopy[index.index], [key]: { ...datacopy[index.index]?.[key] ?? {}, [name]: value } }
      }
      setData(() => datacopy)
    } else if (name == 'maxCharacters' && !value) {

      if (setValues) {
        setValues({ name, value: '1' })
        datacopy[index.index] = { ...datacopy[index.index], [key]: { ...datacopy[index.index]?.[key] ?? {}, [name]: '1' } }
        setData(() => datacopy)
      }
    }
  }

  const config = (value: boolean) => {
    if (value) {
      setData([])
      setExpand([])
      setTabValue('1')
    }
    setOptions({ sameConfig: value })
  }

  const closeModal = () => { setModal(prev => ({ ...prev, open: false, cancel: () => { }, confirm: undefined })) }

  const confirm = () => {
    cancel()
    closeModal()
    setExistCheck([{}])
    setTabValue('1')
  }
  const addTempalte = () => {
    let listTemplate = structuredClone(data)
    let listExpand = structuredClone(expand)
    if (options.sameConfig) {
      listTemplate = [evidenceTemplate, evidenceTemplate]
      listExpand = [expandTemplate, expandTemplate]
    } else {
      listTemplate[index.index] = evidenceTemplate
      listExpand[index.index] = expandTemplate
    }
    setData(listTemplate)
    setExpand(listExpand)
  }

  const onChange = (e: onChangeEvent, blur: IsBlur) => {
    const { name, value } = e.target
    const datacopy = structuredClone(data)
    const foundData = datacopy[index.index]
    let newValue = value
    if ('maxCharacters' == name && blur?.blur && value < 1) {
      newValue = '1'
    }
    datacopy[index.index] = { ...foundData, [EvidencesTypeEnum.OBSERVATION_COMMENT]: { ...foundData?.[EvidencesTypeEnum.OBSERVATION_COMMENT] ?? {}, [name]: newValue, type: index?.item?.type, active: true } }
    setData(datacopy)
  }

  useLayoutEffect(() => {
    if (!!props.open) {
      let defaultData = removeAllReference(props.defaultValues) || []
      const expandList: Record<string, boolean>[] = []
      if (selectEvidence.folioManagement) {
        const existObservationCommentApprove = props.defaultValues?.find(item => item.observation_comment && item.observation_comment?.type == typeUser.APPROVER)
        const existObservationCommentReject = props.defaultValues?.find(item => item.observation_comment && item.observation_comment?.type == typeUser.REJECT)
        if (!existObservationCommentApprove) {
          const indexApprove = defaultData?.findIndex(item => item.observation_comment?.type == typeUser.A)
          if (indexApprove >= 0) {
            defaultData[indexApprove] = {
              ...defaultData[indexApprove],
              [EvidencesTypeEnum.OBSERVATION_COMMENT]: folioManagementDefault
            }
          } else {
            defaultData.push({ [EvidencesTypeEnum.OBSERVATION_COMMENT]: folioManagementDefault })
          }
        }
        if (!existObservationCommentReject) {
          const indexApprove = defaultData?.findIndex(item => item.observation_comment?.type == typeUser.REJECT)
          if (indexApprove >= 0) {
            defaultData[indexApprove] = {
              ...defaultData[indexApprove],
              [EvidencesTypeEnum.OBSERVATION_COMMENT]: { ...folioManagementDefault, type: typeUser.REJECT }
            }
          } else {
            defaultData.push({ [EvidencesTypeEnum.OBSERVATION_COMMENT]: { ...folioManagementDefault, type: typeUser.REJECT } })
          }
        }
      }
      for (const index in (defaultData || [])) {
        expandList.push({})
        for (const [key, value] of Object.entries({ ...defaultData?.[index] } ?? {})) {
          expandList[index] = { ...expandList[index] ?? {}, [key]: !!value?.active }
          // setExpand(prev => ([...prev, { ...prev[index], [key]: !!value?.active }]))
        }
      }
      setExpand(expandList)
      setOptions({ sameConfig: !!props.options?.sameConfig })
      setData(defaultData || [])
    }
  }, [props.defaultValues, props.open])
  return (
    <Drawer
      sx={styles.drawer}
      anchor="right"
      open={props.open}
    >
      {!!headerLabel && (
        <ArrowBack
          arrowProps={{
            onClick: closeEvidence,
            sx: {
              padding: '10px 20px 10px 0px',
            }
          }}
          label={headerLabel}
          boxProps={{
            sx: {
              marginLeft: '-20px'
            }
          }}
        />
      )}
      {Boolean(props.headerElement) && props.headerElement}

      {(!Boolean(props.headerElement)) && <Typography sx={styles.titleEvidences}>{t('general.evidence')}</Typography>}

      {
        !!selectEvidence.creator && (
          <FormControlLabel
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9rem' }, marginBottom: 2 }}
            control={
              <IOSSwitch
                name="notified"
                checked={options.sameConfig}
                onChange={({ target }) => {
                  config(target.checked)
                }}
                sx={{ m: 1 }}
              />
            }
            label={t('general.useSameConfig')}
          />
        )
      }
      <TabContext value={tabValue}>
        {(selectEvidence.creator || selectEvidence.folioManagement) &&
          (
            <TabList disabled={options.sameConfig} sx={styles.tabList} onChange={(_, value) => {
              setTabValue(value)
            }} variant="fullWidth" aria-label="lab API tabs example">
              {
                list?.map(item => <Tab disabled={options.sameConfig} label={item.label} value={item.value} />)
              }
            </TabList>
          )}


        <TabPanel sx={{ padding: '20px 2px', }} value={String(index.index + 1)}>
          {(!!selectEvidence.folioManagement && canSeeObservation) &&
            <DinamicForm
              input={Object.values(inputObservationComment)}
              onChange={onChange}
              disabled={disabledField}
              values={currentData?.[EvidencesTypeEnum.OBSERVATION_COMMENT] || folioManagementDefault}
            />}

          {!!selectEvidence.folioManagement && <Typography sx={styles.titleEvidences}>{t('general.evidence')}</Typography>}

          <Item
            disabledField={disabledField}
            index={index.index}
            addData={addData}
            data={currentData}
            existCheck={existCheck?.[index.index]}
            expand={expand?.[index.index]}
            refs={refs}
            validateData={validateData}
          />
        </TabPanel>
      </TabContext>

      <SimpleModal
        open={!!modal.open}
        close={closeModal}
        title={modal.title}
        description={modal.description}
        cancelText={modal.cancelText ?? t('general.cancel')}
        buttonText={modal?.confirmText ?? t('general.confirm')}
        back={modal.cancel !== undefined ? closeModal : undefined}
        next={modal?.confirm ?? confirm}
      />

      {
        (!!selectEvidence.creator || !!selectEvidence.activityManagement) && (
          <Button sx={styles.defaultBtn} onClick={addTempalte} variant="contained">{t('general.defaultSetting')}</Button>
        )
      }
      {
        !disabledField && (
          <ButtonsDrawer
            accept={{
              title: t('general.save'),
              disabled: props.disabledButon ?? false,
              onClick: () => { save() },
            }}
            cancel={{
              title: t('general.cancel'),
              onClick: () => {
                cancel()
                setTabValue('1')
                setOptions({ sameConfig: false })
              },
            }}
          />
        )
      }
    </Drawer>
  )
}

export { DrawerEvidences }